// extracted by mini-css-extract-plugin
export default {"container":"MyStudents_container__37Ata","table":"MyStudents_table__NYV3t"};